import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import TabHeader from './tab_header';

// An ordered group of clickable headers, one of which is active.
export default class TabHeaders extends React.Component {
  static propTypes = {
    children: PropTypes.arrayOf(
      PropTypes.shape({ type: PropTypes.oneOf([TabHeader]) }),
    ).isRequired,
    activeName: PropTypes.string,
    className: PropTypes.string,
    onActivate: PropTypes.func,
    a11yKeyboard: PropTypes.bool,
    a11yRolesErb: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    activeName: null,
    onActivate: () => {},
    a11yKeyboard: false,
    a11yRolesErb: false,
  };

  state = {
    isOpen: false,
  };

  componentDidMount() {
    document.addEventListener('click', this.handleClosingMenu);
    window.addEventListener('resize', this.handleClosingMenu);
  }

  hideMenu = () => {
    this.setState(() => ({ isOpen: false }));
  };

  toogleMenu = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  handleClosingMenu = (ev) => {
    if (!ev.target.classList || !ev.target.classList.contains('tab-headers')) {
      this.hideMenu();
    }
  };

  handleClick = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    this.toogleMenu();
    return;
  };

  handleKeyDown = (ev) => {
    const { children, activeName, onActivate } = this.props;
    const names = React.Children.map(children, (child) => child.props.name);
    const current = names.indexOf(activeName);
    let next;
    if (ev.key === 'ArrowRight') next = (current + 1) % names.length;
    else if (ev.key === 'ArrowLeft')
      next = (current - 1 + names.length) % names.length;
    else if (ev.key === 'Home') next = 0;
    else if (ev.key === 'End') next = names.length - 1;
    else return;

    ev.preventDefault();
    onActivate(names[next]);
    const tab = ev.currentTarget.querySelectorAll('[role="tab"]')[next];
    if (tab) tab.focus();
  };

  render() {
    const {
      children,
      activeName,
      className,
      onActivate,
      a11yKeyboard,
      a11yRolesErb,
    } = this.props;
    const hasTabSemantics = a11yKeyboard || a11yRolesErb;
    const { isOpen } = this.state;

    const clonedChildren = React.Children.map(children, (child) =>
      React.cloneElement(child, {
        activeName,
        onClick: () => onActivate(child.props.name),
        a11yKeyboard,
        a11yRolesErb,
      }),
    );
    const activeLabel = clonedChildren.find(
      (child) => child.props.name === activeName,
    ).props.label;

    return (
      <div
        className={cn('tab-headers', className, { open: isOpen })}
        data-content={activeLabel}
        onClick={this.handleClick}
        {...(hasTabSemantics
          ? { role: 'tablist', onKeyDown: this.handleKeyDown }
          : {})}
      >
        {clonedChildren}
      </div>
    );
  }
}
